/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/ongoing/axiomatic-math.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/ongoing/axiomatic-math.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/axiomatic-math.mdx';

const metadata = {
  slug: "axiomatic-math",
  title: "Axiomatic Math",
  author: "Christian Battaglia",
  description: "What's the minimum number of axioms a system needs? From Robinson arithmetic to Godel's incompleteness theorems, the travelling salesman problem, and the cryptographic implications of number theory — an ongoing deep dive into the foundations of math.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-09-04T00:00:00.000Z",
  
  readTime: "3 min read",
  tags: ["mathematics","philosophy","axioms","Godel","Robinson arithmetic","P vs NP","cryptography","number theory"],
};

export const Route = createFileRoute('/blog/posts/axiomatic-math')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/axiomatic-math',
    image: '/og/blog/axiomatic-math.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
